// extracted by mini-css-extract-plugin
module.exports = {"embeddedcontent":"embeddedcontent-module--embeddedcontent--H_Gk8"};